<template>
  <div class="main-content" ref="sub">
    <vxe-toolbar size="mini">
      <template v-slot:buttons>
        <!-- <vxe-button size="medium" type="primary" :loading="load"  class='vxe-btn-primary' icon="el-icon-plus"  @click="insertEvent()">
              {{$t("xTable.insert")}}
            </vxe-button> -->
        <div style="padding-bottom: 10px">
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-delete"
            icon="el-icon-delete"
            @click="deleteEvent()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-disable"
            />
            {{ $t('xTable.disable') }}
          </vxe-button>
          <vxe-button
            size="medium"
            type="primary"
            :loading="load"
            class="vxe-btn-save"
            @click="save()"
          >
            <svg-icon
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              icon-class="icon-preserve"
            />
            {{ $t('xTable.save') }}
          </vxe-button>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTable"
      class="vxe-table-element"
      size="mini"
      align="left"
      :loading="load"
      :auto-resize="true"
      :edit-rules="editRules"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="formulaType"
        :title="$t('creditCalculation.formulatType')"
      ></vxe-table-column>
      <vxe-table-column
        field="formulaContent"
        :title="$t('creditCalculation.formula')"
        :edit-render="clear"
      ></vxe-table-column>
      <vxe-table-column field="controlareaCode" :title="$t('creditCalculation.controlareaName')">
        <!-- <template v-slot:edit="scope">
            <treeselect
              :options="businessDepartmentList"
              v-model="scope.row.controlareaCode"
              :defaultExpandLevel="Infinity"
              openDirection="auto"
              :clearable="false"
              :maxHeight="200"
              :zIndex="2999"
              :flat="true"
              :append-to-body="true"
              @select="(val)=>selectNode(val,scope)"
              :placeholder="$t('company.treeselect.searchIndex')"
              :noResultsText="$t('company.treeselect.noData')"
              :searchPromptText="$t('company.treeselect.searchIndex')"
              :normalizer="normalizer"
            />
          </template> -->
        <template v-slot="{ row }">{{ row.controlareaName }}</template>
      </vxe-table-column>
      <vxe-table-column field="isAvailable" :title="$t('creditCalculation.formulaStatus')">
        <template slot-scope="scope">
          <span>
            {{ statusData[scope.row['isAvailable']] }}
          </span>
        </template>
      </vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import SearchModal from '@/components/SearchModal';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import DataBaseAPI from '@/api/dataBase';
  export default {
    name: 'Formula',
    components: {
      // SearchModal,
    },
    data() {
      return {
        load: false,
        formulatTypeList: [],
        statusData: [
          this.$t('applicationCredit.msg.disable'),
          this.$t('applicationCredit.msg.startUse'),
        ],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        normalizer(node) {
          //只能选择根节点
          if (node.children) {
            node.children.map((item) => {
              item['isDisabled'] = true;
            });
          }
          return node;
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      clear() {
        return {
          name: 'ElInput',
          props: { clearable: true, maxlength: '32' },
        };
      },
      editRules() {
        return {
          formulaType: [
            {
              required: true,
              message: this.$t('creditCalculation.formulaTypeNoPlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
          formulaContent: [
            {
              required: true,
              message: this.$t('creditCalculation.formulatTypePlaceholder'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {
      // this.getDic()
      this.getData();
      this.initDepartment();
    },
    methods: {
      //获取字典值
      //  getDic(){
      //   let tenantCode = this.userInfo.userInfo.tenantCode
      //   //公式类型
      //   this.$axios.post(API.LIST_FORMULAT_TYPE,{dictType:'partner_type',tenantCode}).then(res => {
      //        if (0 == res.data.code && res.data.data.length) {
      //          this.formulatTypeList = res.data.data.map(item=>{
      //            return {
      //              label:item.formulaName,
      //              value:item.id
      //            }
      //          })
      //        }
      //      });
      //  },
      //获取数据
      getData() {
        let query = {
          //isFormula:1
        };
        this.$axios.post(API.LIST_FORMULAT_TYPE, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //新增一行
      insertEvent() {
        let userInfo = this.userInfo.userInfo;
        const record = {
          formulaType: null,
          formulaContent: null,
          isAvailable: '0',
          tenantCode: userInfo.userCode,
          companyCode: userInfo.companyCode,
          companyName: userInfo.companyName,
          departmentCode: userInfo.departmentCode,
          departmentName: userInfo.departmentName,
        };
        this.$refs.xTable.insert(record).then(({ row }) => this.$refs.xTable.setActiveRow(row));
      },
      //禁用
      deleteEvent() {
        let selectRecords = this.$refs.xTable.getCheckboxRecords();
        if (selectRecords.length) {
          let idList = [];
          //禁用时记录禁用明细id
          selectRecords.map((item) => {
            if (item.id) {
              idList.push(item.id + '');
            }
          });
          //调用禁用接口
          this.$axios.post(API.DEL_FORMULAT, { ids: idList }).then((res) => {
            if (res.data.code == '0') {
              this.getData();
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
      },
      //判断行项目是否可以编辑
      editable(row) {
        if (row.row.formulaContent) {
          return false;
        } else {
          return true;
        }
      },
      //事业部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
          treeFlag: 1,
          currentStatus: '0',
        };
        this.$axios.post(DataBaseAPI.LIST_CONTROL_AREA_DEPARTMENT_API, params).then((res) => {
          if (0 == res.data.code && res.data.data && res.data.data.length > 0) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //选中节点
      selectNode(val, scope) {
        scope.row.controlareaCode = val.id;
        scope.row.controlareaName = val.label;
        this.$refs.xTable.updateStatus(scope);
      },
      //保存
      save() {
        this.$refs.xTable.validate((valid) => {
          if (valid) {
            const data = this.$refs.xTable.getTableData().fullData;
            if (data.length) {
              this.load = true;
              this.$axios.post(API.SAVE_FORMULAT, { list: data }).then((res) => {
                if (res.data.code == '0') {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.getData();
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
                this.load = false;
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('creditCalculation.msg.addData'),
                type: 'error',
              });
            }
          }
        });
      },
    },
  };
</script>
